import { Link } from "react-router";
import { styled } from "styled-components";

import { LeftArrow, UIButton } from "common/components";

const StyledArrow = styled(LeftArrow)`
  width: 14px;
  height: 14px;
  margin-right: 0.5rem;
`;

type BackButtonProps = { label: string; path: string };

export const BackButton = ({ path, label }: BackButtonProps) => (
  <UIButton as={Link} to={path} variant="neutral">
    <StyledArrow />
    {label}
  </UIButton>
);
